//todo move to custom bootstrapvalidator
//todo better name switchDomainAvailabilityAlert
function switchDomainValidationAlert(alertName) {
    var alerts = document.querySelectorAll('#domain_form_content .alert');
    for (var i = 0; i < alerts.length; ++i) {
        alerts[i].style.display = "none";
    }
    document.querySelector('#domain_form_content .alert-'+alertName).style.display = "flex";

    //add form wrapper state class has-*
    var formGroup = document.getElementById('domain_name_form_group');
    var stateList = ['warning', 'success', 'danger'];
    var formStateName = alertName === 'danger' ? 'error' : alertName;
    for(i = 0; i < stateList.length; i++) {
        formGroup.classList.remove("has-"+stateList[i]);
    }
    formGroup.classList.add("has-"+formStateName);
}

module.exports = switchDomainValidationAlert;
